// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__TCsV7","topBottomGutter":"Layout_topBottomGutter__1_tYP"};